import { getAssetsByDtsTemplateId, getAssetsByTemplateToken } from '../api/get-design-assets';
import { getArea } from '../api/get-content-area';
import { Tenant } from '../api/model/tenant';
import config from '../config';

const slashEncodeString = '%2F';

const extractTemplateIdFromAdtifUrl = (adtif?: string): [string | undefined, boolean] => {
  if (!adtif) return [undefined, false];

  if (adtif.includes('designtemplate.content.cimpress.io')) {
    adtif = adtif.replaceAll(slashEncodeString, '/');
    const matches = adtif.match('/designs/([0-9a-f-]*)');
    if (!matches) return [undefined, false];
    const match = matches[0];
    const templateId = match.slice(match.lastIndexOf('/') + 1);
    return [templateId, false];
  }

  if (adtif.includes(config.deliveryServiceUrl)) {
    const urlObj = new URL(adtif);
    const templateToken = urlObj.searchParams.get('templateToken') ?? undefined;
    return [templateToken, templateToken !== undefined];
  }
  return [undefined, false];
};

export const getCamUrlFromAdtifUrl = async (
  adtifUrl: string | undefined,
  tenant: Tenant,
): Promise<string | undefined> => {
  const [templateId, isTemplateToken] = extractTemplateIdFromAdtifUrl(adtifUrl);
  if (!templateId) {
    return undefined;
  }

  const assetsResponse = isTemplateToken
    ? await getAssetsByTemplateToken(templateId, tenant)
    : await getAssetsByDtsTemplateId(templateId, tenant);
  if (assetsResponse.data.length === 0) {
    return undefined;
  }

  const area = getArea(tenant.accountId, tenant.areaId);
  const asset = assetsResponse.data[0];
  return `${config.camUrl}/accounts/${area.contentAuthoringAccountId}/contentarea/${area.contentAuthoringAreaId}/${asset.assetKind}s?search=${asset.id}`;
};
